import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosClient from '../api/axiosClient';
import styled from 'styled-components';
import Button from '../components/Button/Button';
import Typography from '../components/Typography';
import { theme } from '../theme';


const VerifyEmail = () => {
  const { t } = useTranslation('verifyEmail');
  const location = useLocation();
  const email = location.state?.email || 'tu correo';
  const returnTo = location.state?.returnTo || '/discover';

  const [seconds, setSeconds] = useState(10);  // Temporizador de 10 segundos
  const [canResend, setCanResend] = useState(false);  // Control para habilitar el botón

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prevSeconds => {
        if (prevSeconds === 1) {
          clearInterval(interval);
          setCanResend(true);  // Habilitar el botón después de 10 segundos
        }
        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(interval);  // Limpiar intervalo cuando el componente se desmonte
  }, []);

  const handleResend = async () => {
    try {
      await axiosClient.post('/api/users/check-or-register', { email, returnTo });
      setSeconds(10);  // Reiniciar el temporizador
      setCanResend(false);  // Deshabilitar el botón de nuevo
    } catch (error) {
      console.error('Error reenviando el email:', error);
    }
  };


  return (
    <OveralyWrapper>
      <EmailConfirmation>
        <Header>
          <Typography as="h1" $variant="body-1-semibold">{t('title')}</Typography>
        </Header>
        <Wrapper>
          <InnerWrapper>
            <Typography as="p" $variant="body-1-semibold">{t('loginLinkSent')}</Typography>
            <Typography as="p" $variant="body-2-medium">{t('emailSentTo')}</Typography>
            <EmailWrapper>
              <UserEmail as="span" $variant="body-2-medium" color={theme.colors.brandMain}>{email}</UserEmail>
              <BackLink to="/signin" state={{ returnTo }}>
                <Typography as="span" $variant="body-2-medium" color={theme.colors.defaultMain}>{t('notYou')}</Typography>
              </BackLink>
            </EmailWrapper>
          </InnerWrapper>
          <Button $variant='outline' onClick={handleResend} disabled={!canResend} title="Reenviar email">
            {canResend ? t('resendEmail') : t('resendInSeconds', { seconds })}
          </Button>
          <Typography as="p" $variant="body-2-medium" color={theme.colors.defaultWeak}>{t('checkSpam')}</Typography>
        </Wrapper>
      </EmailConfirmation>
    </OveralyWrapper >
  );
};

export default VerifyEmail;

const OveralyWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.fill.inverseStrong};
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.sizing.sm};
`;

const EmailConfirmation = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.fill.defaultMain};
  border-radius: ${({ theme }) => theme.radius.xs};
  display: flex;
  flex-direction: column;
  max-width: 470px;
`;

const Header = styled.div`
  align-items: center; 
  border-bottom: 1px solid ${({ theme }) => theme.border.defaultWeak};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  padding: ${({ theme }) => theme.sizing.sm};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const EmailWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: flex-start;
`;

const UserEmail = styled(Typography)`
  text-decoration: underline;
`;

const BackLink = styled(Link)`
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.5;
  }
`;